import React, { Fragment, useEffect, useState } from "react";
import { Image } from "lib";
import { useDispatch, useSelector } from "react-redux";
import option from "../../assets/images/option.svg";
import "./index.scss";
import { useRef } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";  
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  recursiveRead,
  setDeleteSaveData,
  setDeleteShowData,
  setShowRecursiveForm,
  setShowDataPreview,
  setAssociatedWf,
  setIsMinor,
  setIsMinorEdit,
  setIsEditMinor,
  setIsAssociated,
  setAssociateRequired,
  setCurrentFormType,
  setRecursiveFormData,
  clearRecursiveFormData,
  setEditIndex,
} from "redux/guardianReducer";
import {
  getAllGuardians,
  getDependentsId,
  getDependentsNames,
  getGuardiansId,
} from "helper";
import { setEditSaveData, setEditShowData } from "redux/guardianReducer";
const GuardianRecursiveDataPreview = ({
  recursiveRead,
  recursiveTrigger,
  data,
  item,
  handleEditChange,
}) => {
  const dispatch = useDispatch();
  //fetch requestedId from the url query
  const requestedDocs = useSelector(
    (state) => state.requestedDocReducer.requestedDocs
  );
  const disableDelete = requestedDocs?.requestedFlow;

  const showData = useSelector((state) => state.guardianRecursive?.showData);
  const saveData = useSelector((state) => state.guardianRecursive?.saveData);
  const isEditRecursiveForm = useSelector(
    (state) => state.guardianRecursive?.isEditRecursiveForm
  );
  const showRecursiveForm = useSelector(
    (state) => state.guardianRecursive?.showRecursiveForm
  );
  const guardianKey = useSelector(
    (state) => state.guardianRecursive?.guardianKey
  );
  const associateRequired = useSelector(
    (state) => state.guardianRecursive.associateRequired
  );
  const currentFormType = useSelector(
    (state) => state.guardianRecursive.currentFormType
  );
  const recursiveFormData = useSelector(
    (state) => state.guardianRecursive.recursiveFormData
  );
  const guardianLabel = useSelector(
    (state) => state.guardianRecursive.guardianLabel
  );
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const maxActiveGroup = useSelector((state) => state.userInfo.maxActiveGroup);
  const maxActiveSection = useSelector(
    (state) => state.userInfo.maxActiveSection
  );
  let loggedUserId = loggedInUserInfo?.profileInfo?.userId || null;
  const inputFields = useSelector((state)=> state?.guardianRecursive?.formFields)
  const primaryUser = useSelector((state) => state.userInfo?.primaryUser);
  const [isClicked, setIsClicked] = useState(false);
  const [selectedId, setSelectedId] = useState();
  const [guardianList, setGuardianList] = useState([]);
  const maxGuardianLimit = useSelector(
    (state) => state.guardianRecursive.maxGuardianLimit
  );
  const stateEditIndex = useSelector(
    (state) => state.guardianRecursive.editIndex
  );
  const search = window.location.search;
  const query = new URLSearchParams(search);

  const requestedId = React.useMemo(() => {
    //optimization
    return query.get("requestedId");
  }, [search, query]);
  const handleClickOutside = () => {
    setIsClicked(false);
    setGuardianList([]);
  };
  const ref = useOutsideClick(handleClickOutside);

  const handleOptionChange = (index) => {
    setSelectedId(index);
    setIsClicked(!isClicked);
    dispatch(setEditIndex(index));
  };

  const handleDelete = (index) => {
    if (recursiveTrigger) {
      //* check if the person deleted is applicant then delete all his dependents guardians
      if (!saveData[index].hasOwnProperty("guardian_of")) {
        let allGuardians = [],
          guardianInfo = {},
          guardianInfoShow = {};
        allGuardians = getGuardiansId(saveData, saveData[index].uid);
        allGuardians.forEach((guardianId) => {
          let guardian = saveData.find(
            (applicant) => applicant.uid === guardianId
          );
          let guardianIndex = saveData.findIndex(
            (applicant) => applicant.uid === guardianId
          );
          if (guardian.guardian_of.includes(saveData[index].uid)) {
            guardianInfo = {
              ...saveData[guardianIndex],
            };
            guardianInfoShow = {
              ...showData[guardianIndex],
            };
            if (Object.keys(guardianInfo).includes("guardian_of")) {
              const filteredGuardians = guardianInfo.guardian_of.filter(
                (applicant) => applicant !== saveData[index].uid
              );
              guardianInfo.guardian_of = filteredGuardians;
              guardianInfoShow["guardian_of"] = getDependentsNames(
                filteredGuardians,
                saveData,
                guardianKey
              ).join(",");
              if (guardianInfoShow.guardian_of === "")
                delete guardianInfoShow["guardian_of"];
              dispatch(
                setEditShowData({
                  editIndex: guardianIndex,
                  data: guardianInfoShow,
                })
              );
            }
            dispatch(
              setEditSaveData({ editIndex: guardianIndex, data: guardianInfo })
            );
            //    if (guardianInfo?.guardian_of?.length === 0) {
            //   dispatch(setDeleteSaveData(guardianIndex));
            //   dispatch(setDeleteShowData(guardianIndex));
            // }
          }
          //* if the found guardian doesnt have any other dependents except the one being deleted, We will delete him
        });
      }
    }
    //* delete the index selected
    dispatch(setDeleteShowData(index));
    dispatch(setDeleteSaveData(index));
    //*clear the data so form doesnt get repopulated on delete
    dispatch(clearRecursiveFormData());
    setIsClicked(false);
  };
  const handleLinkingOfGuardian = (guardian, index) => {
    const guardianIndex = saveData.findIndex(
      (applicant) => applicant.uid === guardian.uid
    );
    let guardianSave = structuredClone(saveData[guardianIndex]),
      guardianShow = structuredClone(showData[guardianIndex]);
    if (
      guardianSave.hasOwnProperty("guardian_of") &&
      guardianSave.guardian_of.includes(saveData[index].uid)
    )
      return;
    const guardiansCount = getGuardiansId(
      saveData,
      saveData[index].uid
    )?.length;
    if (guardiansCount >= maxGuardianLimit) {
      toast("Maximum number of guardians are already linked for this person", {
        type: "error",
        position: "top-right",
        theme: "light",
        toastId: 'errorOfGuardianLimit',
        containerId: "Guardian",
        style: {
          boxShadow: "none"
        }
      });
      return;
    }
    if (guardianSave.hasOwnProperty("guardian_of"))
      guardianSave.guardian_of.push(saveData[index].uid);
    else guardianSave.guardian_of = [saveData[index].uid];
    guardianShow.guardian_of = getDependentsNames(
      guardianSave.guardian_of,
      saveData,
      guardianKey
    ).join(",");
    dispatch(setEditShowData({ editIndex: guardianIndex, data: guardianShow }));
    dispatch(setEditSaveData({ editIndex: guardianIndex, data: guardianSave }));
  };

  useEffect(() => {
    //* reset redux variables to default value when all data is deleted
    if (recursiveTrigger)
      if (saveData.length === 0) {
        dispatch(setCurrentFormType("applicant"));
      }
    dispatch(setAssociateRequired());
  }, [saveData]);

  useEffect(() => {
    if (showData.length === 0) {
      dispatch(setShowDataPreview(false));
      dispatch(setShowRecursiveForm(true));
    }
  }, [showData]);

  const handleEdit = (index) => {
    setIsClicked(false);
    //Editing guardian data // should not do this if recurisve trigger is true
    if (recursiveTrigger) {
      if (saveData[index].hasOwnProperty("guardian_of")) {
        dispatch(setCurrentFormType("associate"));
      } else {
        dispatch(setCurrentFormType("applicant"));
      }
    }
    handleEditChange(index);
  };

  const handleLinkGuardian = (index) => {};

  const titleCase = (s) => {
    if (s === "guardian_of") {
      s = guardianLabel;
    }
    s = s.replaceAll("_", " ");
    let res = s.charAt(0).toUpperCase() + s.slice(1);
    return res;
  };
  const mapValues = (item) => {
    if (Array.isArray(item)) {
      let resString;
      let res = item.map((_item) => _item["value"]);
      resString = res?.join(",");
      // // console.log(resString);
      return resString;
    } else if (typeof item === "object") {
      return item?.original_name;
    } else return item;
  };
  return (
    <>
      {/* Using recursive component */}
      {item?.length && item?.[1] !== true && (
        <div className="preview_item">
          {
            inputFields && inputFields?.map((data)=>{
              if(item?.[0] ==  data?.id){
               return <span className="preview_item_label">{data?.label}</span>
              }
            })
          }
          <span className="preview_item_value">
            {/* {typeof item[1] === "object" ? item?.[1]?.original_name : item?.[1]} */}
            {
              // item?.[1].length
              //   ? mapArrayValues(item?.[1])
              //   : // : Array.isArray(item?.[1])
              //     // item?.[1].length
              //     item?.[1]?.original_name
              // : item?.[1]
              mapValues(item?.[1])
            }
          </span>
        </div>
      )}
      <div className="form-container">
        {data &&
          data.map((item, index) => {
            return (
              <div className="preview" key={index}>
                {Object.keys(item).length &&
                  Object.entries(item).map((_item, index) => {
                    if (
                      _item[0] != "verification_response" &&
                      _item[0] != "signature_position" &&
                      _item[0] != "trigger_esign_request" &&
                      _item[0] != "co_signer" &&
                      _item[0] != "signer_validation_name"
                    ) {
                      return (
                        <Fragment key={index}>
                          <GuardianRecursiveDataPreview item={_item} />
                        </Fragment>
                      );
                    }
                  })}

                {!showRecursiveForm && recursiveRead ? (
                  maxActiveGroup > 1 || maxActiveSection > 1 ? (
                    ""
                  ) : (
                    <button
                      ref={ref}
                      className="option_button mt-2"
                      onClick={() => handleOptionChange(index)}
                    >
                      <Image imageSrc={option} className={`modal_trigger`} />
                      {isClicked && selectedId === index ? (
                        <div className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
                          <button
                            disabled={
                              !loggedUserId &&
                              primaryUser?.created_by != null &&
                              !requestedId
                            }
                            onClick={() => handleEdit(index)}
                            className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey "
                          >
                            Edit
                          </button>
                          <button
                            disabled={
                              !loggedUserId &&
                              primaryUser?.created_by != null &&
                              !requestedId
                            }
                            onClick={() => handleDelete(index)}
                            className={`option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey `}
                          >
                            Delete
                          </button>
                          <div className="link_guardian_container">
                            {recursiveTrigger ? (
                              <>
                                {" "}
                                <button
                                  disabled={
                                    !loggedUserId &&
                                    primaryUser?.created_by != null &&
                                    !requestedId
                                  }
                                  onClick={() => setGuardianList(true)}
                                  className={`option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey `}
                                >
                                  Link Guardian
                                </button>
                                <div className="guardian_list">
                                  {guardianList.length > 0
                                    ? guardianList.map((guardian) => {
                                        return (
                                          <button>guardian.first_name</button>
                                        );
                                      })
                                    : null}
                                </div>{" "}
                              </>
                            ) : null}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </button>
                  )
                ) : (
                  <button
                    ref={ref}
                    className="option_button mt-2"
                    onClick={() => handleOptionChange(index)}
                    disabled={isEditRecursiveForm}
                  >
                    <Image imageSrc={option} className={`modal_trigger`} />
                    {isClicked && selectedId === index ? (
                      <div className="option_list shadow-sm rounded-0 border-0 px-1 mb-2 mx-0 bg-white ">
                        <button
                          disabled={
                            !loggedUserId &&
                            primaryUser?.created_by != null &&
                            !requestedId
                          }
                          onClick={() => handleEdit(index)}
                          className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey "
                        >
                          Edit
                        </button>
                        <button
                          disabled={
                            !loggedUserId &&
                            primaryUser?.created_by != null &&
                            !requestedId
                          }
                          onClick={() => handleDelete(index)}
                          className={`option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey `}
                          // ${
                          //   disableDelete && "radioDisabled"
                          // }`}
                        >
                          Delete
                        </button>
                        {recursiveTrigger &&
                        saveData[stateEditIndex]?.majority?.toLowerCase() ===
                          "minor" ? (
                          <>
                            <OverlayTrigger
                              placement="right"
                              delay={{ hide: 10000 }}
                              overlay={
                                <Popover id={`popover-positioned}`}>
                                  {/* <Popover.Header as="h3">{`Popover`}</Popover.Header> */}
                                  <Popover.Body>
                                    {guardianList.length > 0
                                      ? guardianList.map((guardian) => {
                                          if (
                                            saveData[stateEditIndex].uid !==
                                            guardian.uid
                                          )
                                            return (
                                              <button
                                                className="p-0 bg-white border-0 shadow-none d-block p-1"
                                                onClick={() => {
                                                  handleLinkingOfGuardian(
                                                    guardian,
                                                    index
                                                  );
                                                }}
                                              >
                                                {guardian.first_name}
                                              </button>
                                            );
                                        })
                                      : <span class="preview_item_value">No Guardian Present</span>}
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <button
                                disabled={
                                  !loggedUserId &&
                                  primaryUser?.created_by != null &&
                                  !requestedId
                                }
                                onMouseEnter={() =>
                                  setGuardianList(getAllGuardians(saveData))
                                }
                                className="option_list_item px-2 bg-hover-grey rounded-0 bg-active-grey"
                                variant="secondary"
                              >
                                Link Guardian
                              </button>
                            </OverlayTrigger>
                          </>
                        ) : null}
                      </div>
                    ) : (
                      ""
                    )}
                  </button>
                )}
              </div>
            );
          })}

        {/* Without using recursive function */}
        {/* {
        data && data.map((item, index) => {
          return (
            <div className='preview'>
              {
                Object.keys(item).length && Object.entries(item).map((_item, index) => {
                  return (
                    <div key={index} className="preview_item">
                      <span>{_item[0]}</span>
                      <span>{_item[1]}</span>
                    </div>
                  )
                })
              }
            </div>
          )
        })
      } */}
      </div>  
    </>
  );
};

export default GuardianRecursiveDataPreview;

const useOutsideClick = (callback) => {
  const ref = useRef();
  useEffect(() => {
    const handleClick = (e) => {
      if (e.target.className !== "modal_trigger") {
        callback();
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [ref]);
  return ref;
};
